module.exports = __webpack_public_path__ + "img/baiyan.1e345b47.gif";